import { Control, FieldErrors, useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Section } from 'components/Display/Section/Section';
import { Dropdown } from 'components/Form/Dropdown/Dropdown';

import { DPMM_OPTIONS, SsccSettingsFormState } from '../helpers';

type LabelsSectionProps = {
  control: Control<SsccSettingsFormState>;
  labelOnly: boolean;
  required: boolean;
  errors: FieldErrors<SsccSettingsFormState>['label'];
  disabled: boolean;
};

export const LabelsSection = ({ control, labelOnly, required, errors, disabled }: LabelsSectionProps) => {
  const { t } = useTranslation();
  const { field } = useController({ name: 'label.dpmm', control });

  return (
    <Section.Horizontal
      title={t('settings:ssccSettings.labels.title')}
      description={
        labelOnly
          ? t('settings:ssccSettings.labels.labelOnlyDescription')
          : t('settings:ssccSettings.labels.description')
      }
    >
      <Dropdown
        label={t('settings:ssccSettings.form.dpmm')}
        description={t('settings:ssccSettings.form.dpmmSubtitle')}
        options={DPMM_OPTIONS}
        value={field.value}
        onChange={field.onChange}
        errors={errors?.dpmm}
        disabled={disabled}
        required={required}
        dropdownDisplayTestId="dpmmDropdown"
      />
    </Section.Horizontal>
  );
};
